module.exports = __webpack_public_path__ + "img/verifid.38e8f44d.svg";